var map = {
	"./Avatar.svg": "8Fnn",
	"./aboutProBg.jpg": "Mh6W",
	"./aboutProLogo.svg": "Fgr5",
	"./aboutProPhone.png": "2xW5",
	"./ae_logo.png": "W5Fm",
	"./ae_logo.svg": "yfn/",
	"./blank.png": "Ng9b",
	"./card/logo.svg": "DSsC",
	"./choose.svg": "KDbz",
	"./do.png": "y/NB",
	"./facebook.png": "5Ay2",
	"./facebook2.svg": "TM/7",
	"./hand.png": "o9yr",
	"./ic_check_circle_black_24px.svg": "fc//",
	"./icon-go-back.svg": "eI6h",
	"./iconWhatsapp.svg": "/jrZ",
	"./icon_arrow_grey.svg": "9hqQ",
	"./icon_share_one.png": "0MO7",
	"./icon_share_three.png": "t27/",
	"./icon_share_two.png": "IfAq",
	"./icon_we_use_mssgme_en.svg": "DkyN",
	"./icon_we_use_mssgme_ru.svg": "uzfa",
	"./insta.svg": "o5DE",
	"./insta_share.png": "kpO9",
	"./logo.svg": "zA3n",
	"./logo_bot.svg": "17jI",
	"./man.png": "WMO/",
	"./mc_logo.png": "qEs3",
	"./messengers/icon-facebook-login.svg": "7Sa5",
	"./messengers/icon-facebook.svg": "rIrL",
	"./messengers/icon-line.svg": "FzdF",
	"./messengers/icon-skype.svg": "xk1Y",
	"./messengers/icon-telegram.svg": "sJC1",
	"./messengers/icon-viber.svg": "zY6s",
	"./messengers/icon-vk.svg": "y0Q8",
	"./messengers/icon-whatsapp.svg": "rdQp",
	"./onboarding/analytics.svg": "KZ4r",
	"./onboarding/analytics_integrations.svg": "pmn+",
	"./onboarding/categories.svg": "lhwe",
	"./onboarding/cover.svg": "tbzE",
	"./onboarding/domain.svg": "RspG",
	"./onboarding/googlepay.png": "td/u",
	"./onboarding/link.svg": "X7QK",
	"./onboarding/messengers.svg": "qFRm",
	"./onboarding/no_branding.svg": "C4Pa",
	"./onboarding/pixel.svg": "hJsr",
	"./onboarding/support.svg": "trqa",
	"./power.png": "gHcT",
	"./powered_by_stripe_ol.svg": "3ai1",
	"./robot.png": "v4jp",
	"./stripe.png": "Qlef",
	"./telegram.png": "sav8",
	"./telegram2.svg": "BHCP",
	"./viber.svg": "QJGC",
	"./viber2.svg": "lsIJ",
	"./visa_light.svg": "RbiZ",
	"./visa_logo.png": "H8+p",
	"./vk.svg": "/GFi",
	"./whatsapp.svg": "e66u",
	"./woman.png": "tSrR"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5WF1";